import { render, staticRenderFns } from "./SocialPosts.vue?vue&type=template&id=09c74bcb&scoped=true"
import script from "./SocialPosts.vue?vue&type=script&lang=js"
export * from "./SocialPosts.vue?vue&type=script&lang=js"
import style0 from "./SocialPosts.vue?vue&type=style&index=0&id=09c74bcb&prod&lang=scss&scoped=true"
import style1 from "./SocialPosts.vue?vue&type=style&index=1&id=09c74bcb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c74bcb",
  null
  
)

export default component.exports